var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon04Menus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.00001C2 3.69771 2.13675 3.41163 2.37201 3.22179C2.60726 3.03195 2.91577 2.95872 3.21124 3.02258L12 4.92202L20.7888 3.02258C21.0842 2.95872 21.3927 3.03195 21.628 3.22179C21.8633 3.41163 22 3.69771 22 4.00001V18.0549C22 18.5258 21.6715 18.9329 21.2112 19.0323L12.2112 20.9774C12.0703 21.0079 11.9263 21.0072 11.7888 20.9774L2.78876 19.0323C2.3285 18.9329 2 18.5258 2 18.0549V4.00001ZM11 18.7608V6.75207L4 5.23922V17.2479L11 18.7608ZM13 18.7608V6.75207L20 5.23922V17.2479L13 18.7608Z",
    fill: "#46B476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04Menus);
export default __webpack_public_path__ + "static/media/icon04_menus.80c0f08fc044b3ff1cc6162632839750.svg";
export { ForwardRef as ReactComponent };